import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { LanguageService } from 'src/app/modules/shared/services/language.service';

@Component({
  standalone: false,
  selector: 'app-edit-initial-cost-dialog',
  templateUrl: './edit-initial-cost-dialog.component.html',
  styleUrls: ['./edit-initial-cost-dialog.component.css']
})
export class EditInitialCostDialogComponent implements OnInit {

  variables: any;
  formGroup: FormGroup;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { currentValue: number | null },
    public dialogRef: MatDialogRef<EditInitialCostDialogComponent>,
    private fb: FormBuilder,
    private languageService: LanguageService
  ) {
    this.formGroup = this.fb.group({
      amountCtrl: [data.currentValue ?? null, [Validators.required, Validators.min(0)]]
    });
  }

  ngOnInit(): void {
    this.languageService.translations$.subscribe((vars: any) => {
      this.variables = vars;
    });
  }

  save(): void {
    if (this.formGroup.invalid) {
      this.formGroup.markAllAsTouched();
      return;
    }
    const value = Number(this.formGroup.value.amountCtrl);
    this.dialogRef.close({ value });
  }

  cancel(): void {
    this.dialogRef.close();
  }

  get amountCtrl() {
    return this.formGroup.get('amountCtrl');
  }
}
